import { render } from "./CJZS.vue?vue&type=template&id=b5406f94&scoped=true"
import script from "./CJZS.vue?vue&type=script&lang=js"
export * from "./CJZS.vue?vue&type=script&lang=js"

import "./CJZS.vue?vue&type=style&index=0&id=b5406f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5406f94"]])

export default __exports__